import { EntityTypesSupportedByMapsPage } from "@mapmycustomers/shared/types/entity";
import PinLegend, {
  ColorPinLegend,
  ShapePinLegend,
} from "@mapmycustomers/shared/types/map/PinLegend";
import MapViewState from "@mapmycustomers/shared/types/viewModel/MapViewState";

import { MAP_ENTITY_TYPES } from "@app/util/map/consts";

type DefaultKeys = Partial<Record<EntityTypesSupportedByMapsPage, PinLegend["id"]>>;

type LegendKeys = Pick<MapViewState, "colorKey" | "shapeKey">;

// Keeps a persisted pin legend only if it still exists, else falls back to the org default. Both
// keys come back populated for every entity type, because a missing one silently resolves the org
// default further down in getColorShapeForEntity.
const resolveLegendKeys = (
  persisted: MapViewState | undefined,
  colorLegends: ColorPinLegend[],
  shapeLegends: ShapePinLegend[],
  defaultColorKeys: DefaultKeys,
  defaultShapeKeys: DefaultKeys
): LegendKeys => ({
  colorKey: MAP_ENTITY_TYPES.reduce(
    (acc, entityType) => {
      const persistedId = persisted?.colorKey?.[entityType];
      const stillValid = persistedId && colorLegends.some(({ id }) => id === persistedId);
      acc[entityType] = stillValid ? persistedId : defaultColorKeys[entityType];
      return acc;
    },
    {} as MapViewState["colorKey"] & object
  ),
  shapeKey: MAP_ENTITY_TYPES.reduce(
    (acc, entityType) => {
      const persistedId = persisted?.shapeKey?.[entityType];
      const stillValid = persistedId && shapeLegends.some(({ id }) => id === persistedId);
      acc[entityType] = stillValid ? persistedId : defaultShapeKeys[entityType];
      return acc;
    },
    {} as MapViewState["shapeKey"] & object
  ),
});

export default resolveLegendKeys;
